import React, { Component } from "react";
import { Surface, Shape, Path } from "react-art";
import QRCode from "qrcode.react";
import "./Report.css";
import _ from "lodash";
import Api from "../../api/api";
import { intercept } from "mobx";
import intl from 'react-intl-universal';
import Apiwx from '../../api/wxapi';
import '../person/config'

import { inject, observer } from 'mobx-react';




@inject('store')
@observer
export default class Report extends Component {
    constructor(props) {
        super();
        this.state = {
            showMotor: false,
            showControl: false,
            showSum: false,
            showLights:false,
            showGlass:false,
            showUnderHood:false,
            showUnderVehicle:false,
            showBrakes:false,
            showDamagePhotos:false,
            showInterior:false,
            showTirePressure:false

        };

        this.noteArr = [{ name: intl.get('txt_haoxiaoxi'), color: '#16a11d' },
        { name: intl.get('txt_vedi_Note'), color: '#fecd01' },
        { name: intl.get('txt_replace1'), color: '#fe4019' }]
    }
    componentDidMount() {


    }

    render() {
        let {
            showControl,
            showMotor,
            showSum,
            showLights,
            showGlass,
            showUnderHood,
            showUnderVehicle,
            showBrakes,
            showDamagePhotos,
            showInterior,
            showTirePressure
        } = this.state
        if (this.props.report) {
            var {
                brake_type,
                car,
                manufacturer,
                porduced_year,
                plate_no,
                device_time,
                odometer,
                store,
                model_name,
                conclusion,
                suggestion,
                wear_lf_degree,
                wear_rf_degree,
                wear_lb_degree,
                wear_rb_degree,
                ecc_wear_lf_degree,
                ecc_wear_rf_degree,
                ecc_wear_lb_degree,
                ecc_wear_rb_degree,
                ecc_wear_lf_pos,
                ecc_wear_rf_pos,
                ecc_wear_lb_pos,
                ecc_wear_rb_pos,
                transposition,
                wear_threshold,
                wear_lf_data,
                wear_rf_data,
                wear_lb_data,
                wear_rb_data,
                wear_coordinate_max,
                wear_threshold,
                purpose,
                remark,
                tyre_lb,
                tyre_lf,
                tyre_rb,
                tyre_rf,
                uuid,
                trauma_lf_img,
                trauma_rf_img,
                trauma_lb_img,
                trauma_rb_img,
                language,
                last_wear,
                inspector,//技师名字
                inspector_number,
                wear_lf_value,
                wear_lb_value,
                wear_rf_value,
                wear_rb_value,
                logo,
                 tyreunit,
                model_number,   //cormach.tyrescan.ts004
                create_time,
                inspections,
                season,//夏季胎、冬季胎
            } = this.props.report;
        }
        let purposeStr = purpose ? this.getpurposeStr(purpose) : '-'
        let lang = intl.options.currentLocale
       return (
            <div >
                <div>
                    {/* 顶部信息 */}
                    <div className="report-item">

                        <div className="report-head-info">
                          <div style={{ width: "70%",paddingLeft:10 }}>
                              <div style={{ marginBottom: 8 }}>
                                <img
                                    src={logo ? logo : require('../../assets/logo.png')}
                                    alt=""
                                    style={{ width: 190, height: 51, objectFit: "fill" }} />
                              </div>
                              <div className="report-head-info__item">
                                    <div> <span className="tit ">{intl.get('txt_cphm_dill')}</span></div>
                                    <div> <span className="cnt">{plate_no.toUpperCase()}</span></div>
                             </div>
                          </div>
                          <div style={{ width: "30%" }}>
                            <QRCode
                               value={this.props.store.rootUrl + `report/${uuid}/?lang=` + intl.options.currentLocale}
                               size={88} />
                            <div style={{ whiteSpace: 'pre-wrap',  lineHeight: 1 }}>{intl.get('txt_download_report')} </div>
                          </div>
                        </div>
                        <div className="report-head-info"
                            style={{ paddingLeft: 10, paddingRight: 10 }}>
                            <div style={{ width: "60%" }}>
                               
                                <div className="report-head-info__item">
                                    <div><span className="tit">{intl.get('txt_jcsj_dill')}</span></div>
                                    <div> <span className="cnt">
                                        {" "}
                                        {this.getTimeShow(device_time)}
                                    </span></div>
                                </div>
                                <div className="report-head-info__item">
                                    <div> <span className="tit">{intl.get('txt_chex_dill')}</span></div>
                                    <div> <span className="cnt">{car ? car : "-"}</span></div>
                                </div>
                            </div>
                            <div style={{ width: "40%" }}>
                                <div className="report-head-info__item">
                                    <div> <span className="tit">{intl.get('txt_vechicle_make')}</span></div>
                                    <div> <span className="cnt">{manufacturer ? manufacturer : "-"}</span></div>
                                </div>

                                <div className="report-head-info__item">
                                    <div> <span className="tit">{intl.get('txt_vechicle_year')}</span></div>
                                    <div> <span className="cnt">{porduced_year ? porduced_year : "-"}</span></div>
                                </div> 
                            
                            </div>
                        </div>
                    </div>
                

                    {/* 整体磨损 */}
                    <div className="report-item-ztms-cormach section-4">
                        <div className="report-a">
                            <h2 className="tit">{intl.get('txt_dill_title')}</h2>
                            {tyreunit == 'unit_in' && (<div>{'(' + intl.get('txt_namtishi') + ')'}</div>)}
                        </div>

                        {/* <div className="report-ztms1">
                            <img style={{ height: '28px', marginTop: '4px' }} src={lang == 'zh' ? require("../../assets/report/reportztms.png") : lang == 'it' ? require("../../assets/image/tipydl.png") : lang == 'en' ? require("../../assets/report/tipen.png")
                                : lang == 'fr' ? require("../../assets/report/tipfg.png") : lang == 'ms' ? require("../../assets/report/tipml.png") : lang == 'de' ? require("../../assets/report/tipger.png") : lang == 'ja' ? require('../../assets/report/tipja.png') :
                                    require("../../assets/report/tipxby.png")}></img>
                        </div> */}
                              {this.getRemindView(wear_threshold, tyreunit)}

                        <div className="report-item-main-c" style={{ paddingTop: 132, paddingBottom: 32 }}>
                            {/* <div style={{ width: 1, background: 'gray', height: 70, position: 'relative', left: 40, top: -25 }}></div>
                            <div style={{ width: 1, background: 'gray', height: 70, position: 'relative', left: 40, top: 240 }}></div>
                            <div style={{ width: '35%', background: 'gray', height: 1, position: 'absolute', left: 10, top: 175 }}></div>
                            <div style={{ width: '35%', background: 'gray', height: 1, position: 'absolute', right: 10, top: 175 }}></div> */}
                            <div style={{ position: "relative", }}>
                                <img
                                    style={{
                                        position: "relative",
                                        width: 60,
                                        height: 280,
                                        objectFit: "contain",
                                        zIndex: 10
                                    }}
                                    src={require("../../assets/report/reportcar1.png")}
                                    alt=""
                                />
                                <TyreColor
                                    status={{
                                        lf: {
                                            color: wear_lf_degree
                                        },
                                        rf: {
                                            color: wear_rf_degree
                                        },
                                        lb: {
                                            color: wear_lb_degree
                                        },
                                        rb: {
                                            color: wear_rb_degree
                                        }
                                    }}
                                />
                            </div>
                            <Tyre
                             tyreunit={tyreunit}
                                data={{
                                    lf: {
                                        season:(season&&season.LF)?season.LF:null,
                                        data: wear_lf_data ? wear_lf_data.split(",") : null,
                                        color: wear_lf_degree,
                                        info: tyre_lf,
                                        last: last_wear && last_wear.last_lf_degree ? last_wear.last_lf_degree : '',
                                        level:wear_lf_degree,
                                        pos: ecc_wear_lf_pos
                                    },
                                    rf: {
                                        season:(season&&season.RF)?season.RF:null,
                                        data: wear_rf_data ? wear_rf_data.split(",") : null,
                                        color: wear_rf_degree,
                                        info: tyre_rf,
                                        last: last_wear && last_wear.last_rf_degree ? last_wear.last_rf_degree : '',
                                        level: wear_rf_degree,
                                        pos: ecc_wear_rf_pos
                                    },
                                    lb: {
                                        season:(season&&season.LB)?season.LB:null,
                                        data: wear_lb_data ? wear_lb_data.split(",") : null,
                                        color: wear_lb_degree,
                                        info: tyre_lb,
                                        last: last_wear && last_wear.last_lb_degree ? last_wear.last_lb_degree : '',
                                        level: wear_lb_degree,
                                        pos: ecc_wear_lb_pos
                                    },
                                    rb: {
                                        season:(season&&season.RB)?season.RB:null,
                                        data: wear_rb_data ? wear_rb_data.split(",") : null,
                                        color: wear_rb_degree,
                                        info: tyre_rb,
                                        last: last_wear && last_wear.last_rb_degree ? last_wear.last_rb_degree : '',
                                        level: wear_lb_degree,
                                        pos: ecc_wear_rb_pos
                                    }
                                }}
                            />
                        </div>
                    </div>

                 <div className="report-item section-4">
                        <div className="report-item-head">
                            <h2 className="tit">{intl.get('txt_dill_ltws')}</h2>
                            <div
                                style={{ paddingLeft: 20, paddingRight: 20, paddingLeft: 20, paddingRight: 20, paddingTop: 3, paddingBottom: 3 }}
                                onClick={() => {
                                 this.setState({  showDamagePhotos:!showDamagePhotos })
                                }}><img src={require('../../assets/image/gray_icon.png')} style={{ width: 11, height: 6 }}></img></div>
                      
                        </div>

                        {showDamagePhotos && (  <div>
                        {/* <InstallView data={{ lf: tyre_lf, lb: tyre_lb, rf: tyre_rf, rb: tyre_rb }}> </InstallView > */}
                        <div className="report-item-main">
                            <div style={{ position: "relative" }}>
                                <img
                                    style={{
                                        position: "relative",
                                        width: 100,
                                        height: 280,
                                        objectFit: "contain",
                                        zIndex: 10
                                    }}
                                    src={require("../../assets/report/reportcar1.png")}
                                    alt=""
                                />
                                <TyreColor1
                                    status={{
                                        lf: {
                                            color: tyre_lf
                                        },
                                        rf: {
                                            color: tyre_rf
                                        },
                                        lb: {
                                            color: tyre_lb
                                        },
                                        rb: {
                                            color: tyre_rb
                                        }
                                    }}
                                />
                            </div>

                            <Tyre_ltwg
                                data={{
                                    lf: {
                                        img: trauma_lf_img,
                                        info: tyre_lf
                                    },
                                    rf: {
                                        img: trauma_rf_img,
                                        info: tyre_rf
                                    },
                                    lb: {
                                        img: trauma_lb_img,
                                        info: tyre_lb
                                    },
                                    rb: {
                                        img: trauma_rb_img,
                                        info: tyre_rb
                                    }
                                }}
                            />
                        </div>
                    </div>)}


                 </div>

                </div>
            </div>
        );
    }

    getRemindView(data, tyreunit) {
        let low = data.low / 10;
        let high = data.high / 10;
        let danwei = 'mm'
        if (tyreunit && tyreunit == 'unit_in') {
          low = (low * 1.25984).toFixed(1)
          high = (high * 1.25984).toFixed(1)
          danwei = '/32in'
        }
        return (
          <div className="report-ztms1">
            <img style={{ height: '32px', marginTop: '4px' }} src={require('../../assets/image/bgt.png')}></img>
    
            {data && (<div style={{
              display: "flex", flexDirection: 'row', alignItems: 'center'
              , height: '32px', justifyContent: 'space-between', position: 'absolute', top: '4px', left: 10, right: 10,
              paddingLeft: 10, paddingRight: 10
            }}>
              <div style={{ lineHeight: 1, textAlign: 'center', color: "white", }}>
                <div>{intl.get('txt_replace')}</div>
                <div>{'<' + low + danwei}</div>
              </div>
              <div style={{ lineHeight: 1, textAlign: 'center', color: "white" }}>
                <div>{intl.get('txt_Border')}</div>
                <div>{low + danwei + '-' + high + danwei}</div>
              </div>
              <div style={{ lineHeight: 1, textAlign: 'center', color: "white" }}>
                <div>{intl.get('txt_GoodState')}</div>
                <div>{'≥' + high + danwei}</div>
              </div>
            </div>)}
          </div>
        )
      }


    returnSingle(text1, text2, level, type = 0) {


        if (type == 0) {
            return (
                <div style={{ paddingLeft: 18, paddingRight: 18, marginTop: 10 }}>
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div style={{ lineHeight: 1.5 }}>
                            <div style={{ fontSize: 14, color: 'black' }}>{text1}</div>
                            <div>{text2}</div>
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginRight: 5, width: 100 }}>
                            <div style={{ width: 14, height: 14, background: level == 'high' ? this.noteArr[2].color : level == 'middle' ? this.noteArr[1].color : this.noteArr[0].color, borderRadius: 16 }}></div>
                            {/* <div>{this.getleverstr(level)}</div> */}
                        </div>
                    </div>
                    <div style={{ width: '100%', height: 1, background: '#cbcbcb', marginTop: 10 }}></div>
                </div>
            )
        } else if (type == 1) {
            let temparr = level.split('/')
            return (
                <div style={{ paddingLeft: 18, paddingRight: 18, marginTop: 10 }}>
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div style={{ lineHeight: 1.5 }}>
                            <div style={{ fontSize: 14, color: 'black' }}>{text1}</div>
                            <div>{text2}</div>
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginRight: 60, width: 100 }}>
                            <div style={{ display: 'flex', flexDirection: 'row', fontSize: 14 }}>
                                <span style={{ textDecoration: 'underline', paddingRight: 2, paddingLeft: 2 }}>{temparr[0]}</span>
                                <span>{'/'}</span>
                                <span style={{ textDecoration: 'underline', paddingRight: 2, paddingLeft: 2 }}>{temparr[1]}</span>
                                <span>{'/'}</span>
                                <span style={{ textDecoration: 'underline', paddingRight: 2, paddingLeft: 2 }}>{temparr[2]}</span>
                            </div>
                        </div>
                    </div>
                    <div style={{ width: '100%', height: 1, background: '#cbcbcb', marginTop: 10 }}></div>
                </div>
            )
        } else if (type == 2) {
            return (
                <div style={{ paddingLeft: 18, paddingRight: 18, marginTop: 10 }}>
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div style={{ lineHeight: 1.5 }}>
                            <div style={{ fontSize: 14, color: 'black' }}>{text1}</div>
                            <div>{text2}</div>
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginRight: 60, width: 100 }}>

                            <div>{level}</div>
                        </div>
                    </div>
                    <div style={{ width: '100%', height: 1, background: '#cbcbcb', marginTop: 10 }}></div>
                </div>
            )
        }


    }


    


    getleverstr(level) {
        let str = ''
        if (level == 'high') {
            str = intl.get('txt_levelhigh')
        }
        else if (level == 'middle') {
            str = intl.get('txt_levelmiddle')
        } else {
            str = intl.get('txt_levellow')
        }
        return str
    }

    returnsctixing(data) {
        let str = intl.get('txt_bgtixing')
        let str1 = intl.get('txt_bgtuxubfnr')
        let num = 14;

        switch (data) {
            case 1:
                num = 0;
                break;
            case 2:
                num = 3
                break;
            case 3:
                num = 6
                break;
            case 4:
                num = 10
                break;
            case 5:
                num = 14
                break;
            case 6:
                num = 20
                break;
            case 7:
                num = 27
                break
            case 8:
                num = 39
                break
            case 9:
                num = 55
                break
            case 10:
                num = 87
                break

        }
        str1 = str1.replace(new RegExp("\\{" + 0 + "\\}", "g"), num)
        return str + str1

    }



    returnNote() {
        return (
            <div style={{ paddingLeft: 18, paddingRight: 18, marginBottom: 10 }}>
                {this.noteArr.map((item, index) => {
                    return (
                        <div style={{ display: "flex", flexDirection: 'row', alignItems: 'center', }} key={index}>
                            <div style={{ marginRight: 5, width: 12, height: 12, background: item.color, borderRadius: 12 }}></div>
                            <div>{item.name}</div>
                        </div>
                    )
                })}
            </div>
        )
    }

    getTimeShow(device_time) {
        let lang = intl.options.currentLocale
        if (lang !== 'zh') {
            let temptime = device_time.replace("T", " ")
            let timeArr = temptime.split(' ')

            let time1 = timeArr[0].split('-')


            return time1[2] + '/' + time1[1] + '/' + time1[0] + ' ' + timeArr[1]
        } else {

            return device_time.replace("T", " ")
        }

    }



    getQueryString(name) {
        let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        let r = window.location.search.substr(1).match(reg);
        if (r != null) return decodeURI(r[2]); return null;
    }


    //解析目的：
    getpurposeStr(data) {
        if (data == 'purp_wash') {
            return intl.get('txt_xichemeirong')
        } else if (data == 'purp_alignment') {
            return intl.get('txt_sldw')
        } else if (data == 'purp_replace') {
            return intl.get('txt_guenghuanluntai')
        } else if (data == 'purp_maintain') {
            return intl.get('txt_weixiubaoyang')
        } else {
            return intl.get('txt_qt')
        }
    }

}

const Tyre = props => {
    const _data = props.data;
    let lang = intl.options.currentLocale
    const green = "#36B37E";
    const yellow = "#FFAD26"
    const red = "#FF5230"
    let tyreunit = props.tyreunit;
    _data.lf.position = { left: 15, top: 5 };
    _data.rf.position = { right: 15, top: 5 };
    _data.lb.position = { left: 15, top:290 };
    _data.rb.position = { right: 15, top: 290 };
   
    _data.lf.desc = { left: 0, top: -55 };
    _data.rf.desc = { left: 0, top: -55 };
    _data.lb.desc = { left: 0, top: 20 };
    _data.rb.desc = { left: 0, top: 20 };


    // 返回轮胎位置
    const returnTyrePosition = key => {
        switch (key) {
            case "lf":
                return intl.get('txt_zqlun');
            case "lb":
                return intl.get('txt_zhlun');
            case "rf":
                return intl.get('txt_yqlun');
            case "rb":
                return intl.get('txt_yhlun');
        }
    };
    
    
    const retutnTireName=text=>{
        if(text){
           return intl.get('txt_'+text);
        }else {
            return ''
        }
    }

    // 返回轮胎状态
    const returnTyreStatus = (data, status) => {
        if (data === null) {
            return {
                text: intl.get('txt_ltwjc'),
                color: "#FF5230"
            };
        }
        switch (status) {
            case "high":
                return {
                    text: intl.get('txt_replace1'),
                    color: "#FF5230"
                };
            case "middle":
                return {
                    text: intl.get('txt_Border'),
                    color: "#FFAD26"
                };
            case "low":
                return {
                    text: intl.get('txt_GoodState'),
                    color: "#36B37E"
                };
        }
    };

    const returnTtaumationType = (data) =>{
        if (data){
            if (data.search("trauma_other") != -1){
                data = data.replace(/trauma_other/, '')
            }
            let tra_list = data.split(';')
            if (tra_list.length !== 0){
                // console.log(tra_list);
                return tra_list;
            }
        }
    };
    
    // 返回轮胎状态
    const returnTyreStatus1 = (data, status) => {
        if (data == null || data == '') {
            return {
                text: intl.get('txt_zcd'),
                color: '#36B37E'
            };
        } else {
            let temp = data.split(',');
            let text = temp[3];
            let color = '#4285F4';
         
        //     if (text.indexOf(';') !== -1) {
        //         let temptext = '';
        //         let contenttext=text.match(/trauma_other(\S*)/)[1];
        //         let tempArr = contenttext.split(';')
        //         tempArr.map(item => {
        //             if (item == 'Camber wear') {
        //                 temptext = temptext +' Camber wear'
        //             } 
        //             else if (item == 'trauma_bulge') {
        //                 temptext = temptext + ' ' + intl.get('txt_gubao')
        //             } else if (item == 'trauma_aging') {
        //                 temptext = temptext + ' ' + intl.get('txt_laohua')
        //             } else if (item == 'trauma_lacerate') {
        //                 temptext = temptext + ' ' + intl.get('txt_gelie')
        //             } else if (item == 'trauma_dropblock') {
        //                 temptext = temptext + ' ' + intl.get('txt_diaokuai')
        //             } else if (item == 'trauma_puncture') {
        //                 temptext = temptext + ' ' + intl.get('txt_chaungci')
        //             } else if (item == 'trauma_scratch') {
        //                 temptext = temptext + ' ' + intl.get('txt_cashang')
        //             } else if (item == 'trauma_pinnate') {
        //                 temptext = temptext + ' ' + intl.get('txt_pinnate_wear')
        //             }
        //         })
        //         text = temptext;
        //  } 
            // else {
            //     if (text == 'trauma_normal') {
            //         text = intl.get('txt_zcd')
            //         color = '#36B37E';
            //     } else if (text == 'trauma_bulge') {
            //         text = intl.get('txt_gubao')
            //     } else if (text == 'trauma_aging') {
            //         text = intl.get('txt_laohua')
            //     } else if (text == 'trauma_pinnate') {
            //         text = intl.get('txt_pinnate_wear')
            //     } else if (text == 'trauma_scratch') {
            //         text = intl.get('txt_cashang')
            //     } else if (text == 'trauma_puncture') {
            //         text = intl.get('txt_chaungci')
            //     } else if (text == 'trauma_dropblock') {
            //         text = intl.get('txt_diaokuai')
            //     } else if (text == 'trauma_lacerate') {
            //         text = intl.get('txt_gelie')
            //     }
            //     else if (text.indexOf('trauma_other') !== -1) {
            //         text = text.slice(12)
            //     } else {
            //         text = intl.get('txt_zcd')
            //         color = '#36B37E';
            //     }
            // }
            // let cd = returnTyreInfo(data, 5)
            // if (text.indexOf('trauma_normal') == -1 && cd && cd == 'damage_low') {
            //     color = yellow
            // }
            return {
                text: text,
                color: color
            };
        }
    };



    // 返回轮胎平均值
    const returnTyrePoint = data => {
        let _obj = [];
        let _newObj = [];
        if (data) {
            _obj = _.chunk(data, 4);
            _obj = _obj.map(item => {
                _newObj.push(item[1]);
            });
            _newObj = _newObj.map(item => _.toNumber((item / 10).toFixed(1)));
        }
        return _newObj;
    };


    const returnTyre1 = (status, data) => {
        let _data;
        if (!data) {
          _data = 1;
        } else {
          _data = data.length / 4;
        }
        if (status === "high") {
          return (
            <div style={{ textAlign: "center" }}>
              {_data >= 4 && (
                <img
                  className="tyre"
                  src={require("../../assets/report/tyre-red-1.png")}
                  alt=""
                />
              )}
              {_data === 3 && (
                <img
                  className="tyre"
                  src={require("../../assets/report/tyre-red-2.png")}
                  alt=""
                />
              )}
              {_data === 2 && (
                <img
                  className="tyre"
                  src={require("../../assets/report/tyre-red-3.png")}
                  alt=""
                />
              )}
              {_data === 1 && (
                <img
                  className="tyre"
                  src={require("../../assets/report/tyre-default.png")}
                  alt=""
                />
              )}
            </div>
          );
        }
        if (status === "middle") {
          return (
            <div style={{ textAlign: "center" }}>
              {_data >= 4 && (
                <img
                  className="tyre"
                  src={require("../../assets/report/tyre-yellow-1.png")}
                  alt=""
                />
              )}
              {_data === 3 && (
                <img
                  className="tyre"
                  src={require("../../assets/report/tyre-yellow-2.png")}
                  alt=""
                />
              )}
              {_data === 2 && (
                <img
                  className="tyre"
                  src={require("../../assets/report/tyre-yellow-3.png")}
                  alt=""
                />
              )}
              {_data === 1 && (
                <img
                  className="tyre"
                  src={require("../../assets/report/tyre-default.png")}
                  alt=""
                />
              )}
            </div>
          );
        }
        if (status === "low") {
          return (
            <div style={{ textAlign: "center" }}>
              {_data >= 4 && (
                <img
                  className="tyre"
                  src={require("../../assets/report/tyre-green-1.png")}
                  alt=""
                />
              )}
              {_data === 3 && (
                <img
                  className="tyre"
                  src={require("../../assets/report/tyre-green-2.png")}
                  alt=""
                />
              )}
              {_data === 2 && (
                <img
                  className="tyre"
                  src={require("../../assets/report/tyre-green-3.png")}
                  alt=""
                />
              )}
              {_data === 1 && (
                <img
                  className="tyre"
                  src={require("../../assets/report/tyre-default.png")}
                  alt=""
                />
              )}
            </div>
          );
        }
      };

    const returnTyre = (status, data, pos) => {
        let _data;
        if (!data) {
            _data = 1;
        } else {
            _data = data.length / 4;
        }
        if (status === "high") {
            if (pos == 'middle') {
                return (
                    <div style={{ textAlign: "center" }}>
                        {_data >= 4 && (
                            <img
                                className="tyre1"
                                src={require("../../assets/image/tyre-red-four1.png")}
                                alt=""
                            />
                        )}
                        {_data === 3 && (
                            <img
                                className="tyre1"
                                src={require("../../assets/image/tyre-red-three1.png")}
                                alt=""
                            />
                        )}
                        {_data === 2 && (
                            <img
                                className="tyre1"
                                src={require("../../assets/image/tyre-red-two1.png")}
                                alt=""
                            />
                        )}
                        {_data <= 1 && (
                            <img
                                className="tyre1"
                                src={require("../../assets/image/tyre-two.png")}
                                alt=""
                            />
                        )}
                    </div>
                );
            } else if (pos == 'twoedge') {
                return (
                    <div style={{ textAlign: "center" }}>
                        {_data >= 4 && (
                            <img
                                className="tyre1"
                                src={require("../../assets/image/tyre-red-four2.png")}
                                alt=""
                            />
                        )}
                        {_data === 3 && (
                            <img
                                className="tyre1"
                                src={require("../../assets/image/tyre-red-three2.png")}
                                alt=""
                            />
                        )}
                        {_data === 2 && (
                            <img
                                className="tyre1"
                                src={require("../../assets/image/tyre-red-two2.png")}
                                alt=""
                            />
                        )}
                        {_data <= 1 && (
                            <img
                                className="tyre1"
                                src={require("../../assets/image/tyre-two.png")}
                                alt=""
                            />
                        )}
                    </div>
                );
            } else if (pos == 'left') {
                return (
                    <div style={{ textAlign: "center" }}>
                        {_data >= 4 && (
                            <img
                                className="tyre1"
                                src={require("../../assets/image/tyre-red-four3.png")}
                                alt=""
                            />
                        )}
                        {_data === 3 && (
                            <img
                                className="tyre1"
                                src={require("../../assets/image/tyre-red-three3.png")}
                                alt=""
                            />
                        )}
                        {_data === 2 && (
                            <img
                                className="tyre1"
                                src={require("../../assets/image/tyre-red-two3.png")}
                                alt=""
                            />
                        )}
                        {_data <= 1 && (
                            <img
                                className="tyre1"
                                src={require("../../assets/image/tyre-two.png")}
                                alt=""
                            />
                        )}
                    </div>
                );

            } else if (pos == 'right') {
                return (
                    <div style={{ textAlign: "center" }}>
                        {_data >= 4 && (
                            <img
                                className="tyre1"
                                src={require("../../assets/image/tyre-red-four4.png")}
                                alt=""
                            />
                        )}
                        {_data === 3 && (
                            <img
                                className="tyre1"
                                src={require("../../assets/image/tyre-red-three4.png")}
                                alt=""
                            />
                        )}
                        {_data === 2 && (
                            <img
                                className="tyre1"
                                src={require("../../assets/image/tyre-red-two4.png")}
                                alt=""
                            />
                        )}
                        {_data <= 1 && (
                            <img
                                className="tyre1"
                                src={require("../../assets/image/tyre-two.png")}
                                alt=""
                            />
                        )}
                    </div>
                );
            } else {
                return (
                    <div style={{ textAlign: "center" }}>
                        {_data >= 4 && (
                            <img
                                className="tyre1"
                                src={require("../../assets/image/tyre-red-four5.png")}
                                alt=""
                            />
                        )}
                        {_data === 3 && (
                            <img
                                className="tyre1"
                                src={require("../../assets/image/tyre-red-three5.png")}
                                alt=""
                            />
                        )}
                        {_data === 2 && (
                            <img
                                className="tyre1"
                                src={require("../../assets/image/tyre-red-two5.png")}
                                alt=""
                            />
                        )}
                        {_data <= 1 && (
                            <img
                                className="tyre1"
                                src={require("../../assets/image/tyre-red-two5.png")}
                                alt=""
                            />
                        )}
                    </div>
                );
            }

        }
        if (status === "middle") {
            if (pos == 'middle') {
                return (
                    <div style={{ textAlign: "center" }}>
                        {_data >= 4 && (
                            <img
                                className="tyre1"
                                src={require("../../assets/image/tyre-yellow-four1.png")}
                                alt=""
                            />
                        )}
                        {_data === 3 && (
                            <img
                                className="tyre1"
                                src={require("../../assets/image/tyre-yellow-three1.png")}
                                alt=""
                            />
                        )}
                        {_data === 2 && (
                            <img
                                className="tyre1"
                                src={require("../../assets/image/tyre-yellow-two1.png")}
                                alt=""
                            />
                        )}
                        {_data <= 1 && (
                            <img
                                className="tyre1"
                                src={require("../../assets/image/tyre-two.png")}
                                alt=""
                            />
                        )}
                    </div>
                );
            } else if (pos == 'twoedge') {
                return (
                    <div style={{ textAlign: "center" }}>
                        {_data >= 4 && (
                            <img
                                className="tyre1"
                                src={require("../../assets/image/tyre-yellow-four2.png")}
                                alt=""
                            />
                        )}
                        {_data === 3 && (
                            <img
                                className="tyre1"
                                src={require("../../assets/image/tyre-yellow-three2.png")}
                                alt=""
                            />
                        )}
                        {_data === 2 && (
                            <img
                                className="tyre1"
                                src={require("../../assets/image/tyre-yellow-two2.png")}
                                alt=""
                            />
                        )}
                        {_data <= 1 && (
                            <img
                                className="tyre1"
                                src={require("../../assets/image/tyre-two.png")}
                                alt=""
                            />
                        )}
                    </div>
                );
            } else if (pos == 'left') {
                return (
                    <div style={{ textAlign: "center" }}>
                        {_data >= 4 && (
                            <img
                                className="tyre1"
                                src={require("../../assets/image/tyre-yellow-four3.png")}
                                alt=""
                            />
                        )}
                        {_data === 3 && (
                            <img
                                className="tyre1"
                                src={require("../../assets/image/tyre-yellow-three3.png")}
                                alt=""
                            />
                        )}
                        {_data === 2 && (
                            <img
                                className="tyre1"
                                src={require("../../assets/image/tyre-yellow-two3.png")}
                                alt=""
                            />
                        )}
                        {_data <= 1 && (
                            <img
                                className="tyre1"
                                src={require("../../assets/image/tyre-two.png")}
                                alt=""
                            />
                        )}
                    </div>
                );
            } else if (pos == 'right') {
                return (
                    <div style={{ textAlign: "center" }}>
                        {_data >= 4 && (
                            <img
                                className="tyre1"
                                src={require("../../assets/image/tyre-yellow-four4.png")}
                                alt=""
                            />
                        )}
                        {_data === 3 && (
                            <img
                                className="tyre1"
                                src={require("../../assets/image/tyre-yellow-three4.png")}
                                alt=""
                            />
                        )}
                        {_data === 2 && (
                            <img
                                className="tyre1"
                                src={require("../../assets/image/tyre-yellow-two4.png")}
                                alt=""
                            />
                        )}
                        {_data <= 1 && (
                            <img
                                className="tyre1"
                                src={require("../../assets/image/tyre-two.png")}
                                alt=""
                            />
                        )}
                    </div>
                );
            }else {
                return (
                    <div style={{ textAlign: "center" }}>
                        {_data >= 4 && (
                            <img
                                className="tyre1"
                                src={require("../../assets/image/tyre-yellow-four5.png")}
                                alt=""
                            />
                        )}
                        {_data === 3 && (
                            <img
                                className="tyre1"
                                src={require("../../assets/image/tyre-yellow-three5.png")}
                                alt=""
                            />
                        )}
                        {_data === 2 && (
                            <img
                                className="tyre1"
                                src={require("../../assets/image/tyre-yellow-two5.png")}
                                alt=""
                            />
                        )}
                        {_data <= 1 && (
                            <img
                                className="tyre1"
                                src={require("../../assets/image/tyre-yellow-two5.png")}
                                alt=""
                            />
                        )}
                    </div>
                );
            }
        }
        if (status === "low") {
            return (
                <div style={{ textAlign: "center" }}>
                    {_data >= 4 && (
                        <img
                            className="tyre1"
                            src={require("../../assets/image/tyre-four.png")}
                            alt=""
                        />
                    )}
                    {_data === 3 && (
                        <img
                            className="tyre1"
                            src={require("../../assets/image/tyre-three.png")}
                            alt=""
                        />
                    )}
                    {_data === 2 && (
                        <img
                            className="tyre1"
                            src={require("../../assets/image/tyre-two.png")}
                            alt=""
                        />
                    )}
                    {_data <= 1 && (
                        <img
                            className="tyre1"
                            src={require("../../assets/image/tyre-two.png")}
                            alt=""
                        />
                    )}
                </div>
            );
        }
    };

    // 返回 信息
    const returnTyreInfo = (data, index) => {
        if (data) {
            return data.split(/,|，/)[index] ? data.split(/,|，/)[index] : "-";
        }
        return "-";
    };

    const returnPoint = (data) => {
        let four = [20, 20, 21, 21]
        if (data.length >= 4) {
            return (data.map((point, index) => {
                return (<div key={index} style={{ position: 'relative', left: four[index], width: 20 }}>
                    <div style={{ fontSize: "12px", display: 'flex', flexDirection: 'column', alignItems: 'center', lineHeight: 1 }} >
                        <div style={{ textDecoration: point <= 2.1 ? 'underline' : '' }}> {point}</div>
                        <img style={{ width: 5, height: 10 }} src={point < 1.6 ? redimg : point < 4.5 && point >= 1.6 ? yellowimg : greenimg}></img>
                    </div>
                </div>)

            }))
        }

    }

    const redimg = require('../../assets/image/red.png')
    const yellowimg = require('../../assets/image/yellow.png')
    const greenimg = require('../../assets/image/green.png')
    const returnWear1 = (data) => {
        let str = intl.get('txt_wearlow1')
        let color = green
        if (data == 'high') {
            str = intl.get('txt_wearhigh1')
            color = red
        }
        if (data == 'middle') {
            str = intl.get('txt_wearmiddle1')
            color = yellow
        }
        return {
            text: str,
            color: color

        }
    }
    const returnWear = (data) => {
        let str = intl.get('txt_wearlow')
        let color = green
        if (data == 'high') {
            str = intl.get('txt_wearhigh')
            color = red
        }
        if (data == 'middle') {
            str = intl.get('txt_wearmiddle')
            color = yellow
        }
        return {
            text: str,
            color: color

        }
    }


    return (
        <div>
            {Object.entries(_data).map((item, index) => (
                <div
                    style={Object.assign(item[1].position, { position: "absolute" })}
                    key={index}
                          >
                    <div >
                        <div className="wheelCarDesc1">
                            <label
                                className="wheelCarDesc__label1"
                                >
                                {returnTyrePosition(item[0])+':'+retutnTireName(item[1].season)}
                          </label>
                        </div>

                      <div className='wheelCarDesc1'>
                        <label className="wheelCarDesc__label1 singleline" >
                            {intl.get('txt_wear') + ':'}
                        </label>
                      </div>
                    
                        <div className="wheelCarDesc1-cormach" style={{ color: returnWear1(item[1].level).color }}>
                            {returnWear1(item[1].level).text}
                        </div>
                     

                    </div>

                    <div style={{ marginTop: 10 }}>
                        {returnTyre1(item[1].level, item[1].data, item[1].pos)}
                    </div>

                    <div style={{ 
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-between",
                            alignItems: "center",
                            width:100,
                           }}>
                            {returnTyrePoint(item[1].data).map((point, index) => (
                                <span style={{ fontSize: "12px" }} key={index}>
                                    {/* {point} */}
                                    {tyreunit == 'unit_in'? (point * 1.25984).toFixed(1) : point}
                                </span>
                            ))}
                     </div>
                     

                   {/*<div className="wheelCarDesc">
                        <span style={{ width: '100px', color: returnTyreStatus1(item[1].info).color }} className="wheelCarDesc__cnt">
                                {returnTyreStatus1(item[1].info).text}
                         </span>
                      </div> */}

                         <div >    
                            {returnTtaumationType(returnTyreStatus1(item[1].info).text).map((item, index)=>(
                                    <div    key={index} style={{marginTop:-5}} >
                                        {item !=="Normal"&&item!=="trauma_normal"&&<input  type="checkbox"  style={{width:'10px',height:'10px',backgroundColor:'#0075ff'}}  checked="checked"   readOnly={true}/>}
                                        {(item =="Normal"||item=="trauma_normal")? <span style={{color:'#36B37E'}}>{intl.get('txt_zcd')}</span>:<span style={{color:'#0075ff'}}>{item}</span>}
                                       
                                    </div>
                                 ))} 
                         </div>

                </div>
            ))}

            
        </div>
    );
};


// install
const InstallView = props => {
    let data = props.data;

    const isNormal = (data) => {
        let Arr = [data.lf, data.rf, data.lb, data.rb]
        let flag = true
        Arr.map(item => {
            if (item) {
                let temp = item.split(',');
                if (temp[temp.length - 1] == "install_abnormal") {
                    flag = false
                }
            }

        })
        return flag;

    }

    return (
        <div style={{ flexDirection: "row", paddingLeft: 20, paddingRight: 20, marginTop: 10, alignItems: "flex-start" }}>
            <span style={{ fontSize: 14, fontWeight: "bold", }}>{intl.get('txt_ltazhuang')}</span>
            <span style={{ fontSize: 14, fontWeight: "bold", color: isNormal(data) ? '#36B37E' : "#FF5230" }}>{isNormal(data) ? intl.get('txt_zc') : intl.get('txt_ltfz')}</span>

        </div>
    );
};

// 轮子颜色顺序 左前，右前，左后，右后
// low, 绿色
// middle，黄色
// high，红色
const Frame = props => {
    let _data = {};
    let lang = intl.options.currentLocale
    if (props.data) {
        _data = props.data;
        _data.lf.position = { marginLeft: -25, top: 28 };
        _data.rf.position = { marginLeft: 25, top: 28 };
        _data.lb.position = { marginLeft: -25, top: lang == 'zh' || lang == 'ja' || lang == 'en' ? 97 : 117 };
        _data.rb.position = { marginLeft: 25, top: lang == 'zh' || lang == 'ja' || lang == 'en' ? 97 : 117 };
        _data.lf.desc = {
            position: { left: -140 },
            title: intl.get('txt_hwmsjh')
        };
        _data.rf.desc = {
            position: { right: -140 },
            title: intl.get('txt_hwmsjh')
        };
        _data.lb.desc = {
            position: { left: -140 },
            title: intl.get('txt_hwmsjh')
        };
        _data.rb.desc = {
            position: { right: -140 },
            title: intl.get('txt_hwmsjh')
        };
    }
    if (Object.prototype.toString.call(props.conclusion) === "[object Array]") {
        props.conclusion.forEach(item => {
            if (item.title.indexOf("LF") > -1) {
                if (item.title.indexOf('txt_') > -1) {
                    _data.lf.desc.title = intl.get(item.title.slice(2))
                } else {
                    _data.lf.desc.title = item.title.slice(2);
                }
            }
            if (item.title.indexOf("RF") > -1) {
                if (item.title.indexOf('txt_') > -1) {
                    _data.rf.desc.title = intl.get(item.title.slice(2))
                } else {
                    _data.rf.desc.title = item.title.slice(2);
                }
            }
            if (item.title.indexOf("LB") > -1) {
                if (item.title.indexOf('txt_') > -1) {

                    _data.lb.desc.title = intl.get(item.title.slice(2))
                } else {
                    _data.lb.desc.title = item.title.slice(2);
                }
            }
            if (item.title.indexOf("RB") > -1) {
                if (item.title.indexOf('txt_') > -1) {
                    _data.rb.desc.title = intl.get(item.title.slice(2))
                } else {
                    _data.rb.desc.title = item.title.slice(2);
                }
            }
        });
    }

    // 返回轮胎颜色
    const returnColor = data => {
        if (data === null) {
            return;
        }
        return data === "low"
            ? {
                color: "#36B37E",
                img: require("../../assets/report/tyre-low.png")
            }
            : data === "middle"
                ? {
                    color: "#FFAD26",
                    img: require("../../assets/report/tyre-middle.png")
                }
                : {
                    color: "#FF5230",
                    img: require("../../assets/report/tyre-high.png")
                };
    };

    // 返回轮胎位置
    const returnTyrePosition = name => {
        switch (name) {
            case "lf":
                return intl.get('txt_zqlun');
            case "lb":
                return intl.get('txt_zhlun');
            case "rf":
                return intl.get('txt_yqlun');
            case "rb":
                return intl.get('txt_yhlun');
        }
    };

    //返回轮胎建议
    const returnjianyi = (data, conclusion) => {
        if (conclusion && conclusion[0] && (conclusion[0].title.startsWith('BB') || conclusion[0].title.startsWith('FF'))) {
            let str = conclusion[0].title
            let key1str = intl.get(str.substring(0, 2));
            let key2str = intl.get(str.substring(2, str.length));
            key2str = key2str.replace(new RegExp('异常', "g"), '<*>' + '异常' + '<*>')
            let key2arr = key2str.split('<*>')
            return <p className='cnt'> {intl.get('txt_jianyi')} <span className='redspan'>{key1str}</span> {key2arr.map((item, index) => {
                if (item == '异常') {
                    return (<span key={index} className='redspan'>{item}</span>)
                } else {
                    return (<span key={index} >{item}</span>)
                }

            })}  </p>
        }
        if (data == null) {
            return (<p style={{ fontSize: 14, lineHeight: 1 }}> {intl.get('txt_jianyi') + intl.get('txt_jianyineirongzc')}</p>)
        }

        let str = intl.get('txt_jianyineirongzc');
        data.map(item => {
            if (item[1].data == 'middle' || item[1].data == 'high') {

                str = intl.get('txt_jianyineirong')

            }

        })

        return (<p style={{ fontSize: 14, lineHeight: 1 }}> {intl.get('txt_jianyi') + str}</p>)

    }
    let isuse = lang == 'zh' || lang == 'ja' || lang == 'en'
    return (
        <div style={{
            display: "flex",
            flexDirection: "column"
        }}>
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    position: "relative",
                    flexDirection: "column"
                }}
            >
                <img
                    style={{ width: 50, height: 150, objectFit: "contain" }}
                    src={require("../../assets/report/reportcar1.png")}
                    alt=""
                />
                {Object.entries(_data).map((item, index) => (
                    <div
                        style={Object.assign(item[1].position, { position: "absolute" })}
                        key={item[0]}
                    >
                        <div className="frameDesc" style={item[1].desc.position}>
                            <div>{returnTyrePosition(item[0])}：</div>

                            <div style={{ color: returnColor(item[1].data).color, lineHeight: 1, overflow: 'hidden' }}>


                                {item[1].desc.title}
                            </div>
                        </div>
                        <img
                            style={{ width: 15, height: 25, objectFit: "contain", position: 'relative', top: (index > 1 && !isuse) ? -15 : 0 }}
                            src={returnColor(item[1].data).img}
                            alt=""
                        />
                    </div>
                ))}

                {props.transposition && (
                    <div>
                        {(props.transposition.includes("LF2RF") ||
                            props.transposition.includes("LB2RB")) && (
                                <img
                                    src={require("../../assets/report/huanwei_h.png")}
                                    style={{
                                        position: "absolute",
                                        left: "47.5vw",
                                        top: 120,
                                        width: 20,
                                        objectFit: "contain"
                                    }}
                                    alt=""
                                />
                            )}
                        {(props.transposition.includes("LF2RB") ||
                            props.transposition.includes("RB2LF")) && (
                                <img
                                    src={require("../../assets/report/huanwei_x_left.png")}
                                    style={{
                                        position: "absolute",
                                        left: "45vw",
                                        top: 55,
                                        height: 40,
                                        objectFit: "contain"
                                    }}
                                    alt=""
                                />
                            )}
                        {(props.transposition.includes("RF2LB") ||
                            props.transposition.includes("LB2RF")) && (
                                <img
                                    src={require("../../assets/report/huanwei_x_right.png")}
                                    style={{
                                        position: "absolute",
                                        left: "45vw",
                                        top: 55,
                                        height: 40,
                                        objectFit: "contain"
                                    }}
                                    alt=""
                                />
                            )}
                        {props.transposition.includes("LF2LB") && (
                            <img
                                src={require("../../assets/report/huanwei_v.png")}
                                style={{
                                    position: "absolute",
                                    left: "42vw",
                                    top: 65,
                                    height: 20,
                                    objectFit: "contain"
                                }}
                                alt=""
                            />
                        )}
                        {props.transposition.includes("RF2RB") && (
                            <img
                                src={require("../../assets/report/huanwei_v.png")}
                                style={{
                                    position: "absolute",
                                    left: "55vw",
                                    top: 65,
                                    height: 20,
                                    objectFit: "contain"
                                }}
                                alt=""
                            />
                        )}
                    </div>
                )}
            </div>
            {/* TODO:添加总结 */}
            <div style={{ position: "absolute", paddingLeft: 10, left: 0, bottom: 0 }}>
                {returnjianyi(Object.entries(_data), props.conclusion)}
            </div>

        </div>
    );
};



// 轮胎颜色
const TyreColor = props => {
    const _data = props.status;
    _data.lf.position = { left: -5, top: 85 };
    _data.rf.position = { right: -5, top: 85 };
    _data.lb.position = { left: -5, top: 165 };
    _data.rb.position = { right: -5, top: 165};

    // 返回轮胎状态
    const returnTyreStatus = status => {
        switch (status) {
            case "high":
                return (
                    <img
                        style={{ objectFit: "contain" }}
                        src={require("../../assets/report/tyre-red.png")}
                        alt=""
                    />
                );
            case "middle":
                return (
                    <img
                        style={{ objectFit: "contain" }}
                        src={require("../../assets/report/tyre-yellow.png")}
                        alt=""
                    />
                );
            case "low":
                return (
                    <img
                        style={{ objectFit: "contain" }}
                        src={require("../../assets/report/tyre-green.png")}
                        alt=""
                    />
                );
        }
    };

    return (
        <div style={{ zIndex: -1 }}>
            {Object.entries(_data).map((item, index) => (
                <div
                    style={Object.assign(item[1].position, {
                        position: "absolute",
                        width: 15,
                        height: 30
                    })}
                    key={index}
                >
                    {returnTyreStatus(item[1].color)}
                </div>
            ))}
        </div>
    );
};

// 轮胎外伤颜色
const TyreColor1 = props => {
    const _data = props.status;
    _data.lf.position = { left: -5, top: 85 };
    _data.rf.position = { right: -5, top: 85 };
    _data.lb.position = { left: -5, top: 165 };
    _data.rb.position = { right: -5, top: 165 };
    // 返回 信息
    const returnTyreInfo = (data, index) => {
        if (data) {
            return data.split(/,|，/)[index] ? data.split(/,|，/)[index] : "-";
        }
        return "-";
    };
    // 返回轮胎状态
    const returnTyreStatus = status => {
        console.log('status=' + status);
        let data = returnTyreInfo(status, 3)
        let cd = returnTyreInfo(status, 5)
        if (data && data.indexOf('trauma_normal') == -1) {
            if (cd && cd == 'damage_low') {
                return (
                    <img
                        style={{ objectFit: "contain" }}
                        src={require("../../assets/report/tyre-yellow.png")}
                        alt=""
                    />
                );
            } else if (cd && cd == 'damage_high') {
                return (
                    <img
                        style={{ objectFit: "contain" }}
                        src={require("../../assets/report/tyre-red.png")}
                        alt=""
                    />
                );
            } else if (data.indexOf('trauma') == -1) {
                return (
                    <img
                        style={{ objectFit: "contain" }}
                        src={require("../../assets/report/tyre-green.png")}
                        alt=""
                    />
                );
            } else {
                return (
                    <img
                        style={{ objectFit: "contain" }}
                        src={require("../../assets/report/tyre-yellow.png")}
                        alt=""
                    />
                );
            }

        } else {
            return (
                <img
                    style={{ objectFit: "contain" }}
                    src={require("../../assets/report/tyre-green.png")}
                    alt=""
                />
            );

        }
    };


    return (
        <div style={{ zIndex: -1 }}>
            {Object.entries(_data).map((item, index) => (
                <div
                    style={Object.assign(item[1].position, {
                        position: "absolute",
                        width: 20,
                        height: 40
                    })}
                    key={index}
                >
                    {returnTyreStatus(item[1].color)}
                </div>
            ))}
        </div>
    );
};

{/** 轮胎外观 */ }
const Tyre_ltwg = props => {
    const _data = props.data;
    _data.lf.position = { left: 30, top: 60 };
    _data.rf.position = { right: 30, top: 60 };
    _data.lb.position = { left: 30, top: 180 };
    _data.rb.position = { right: 30, top: 180 };

    _data.lf.desc = { left: 0, top: -30 };
    _data.rf.desc = { right: 0, top: -30 };
    _data.lb.desc = { left: 0, top: -20 };
    _data.rb.desc = { right: 0, top: -20 };

    // 返回 信息
    const returnTyreInfo = (data, index) => {
        if (data) {
            return data.split(/,|，/)[index] ? data.split(/,|，/)[index] : "-";
        }
        return "-";
    };

    // 返回轮胎位置
    const returnTyrePosition = key => {
        switch (key) {
            case "lf":
                return intl.get('txt_zqlun');
            case "lb":
                return intl.get('txt_zhlun');
            case "rf":
                return intl.get('txt_yqlun');
            case "rb":
                return intl.get('txt_yhlun');
        }
    };

    // 返回轮胎状态
    const returnTyreStatus = (data, status) => {

        let yellow = '#FFAD26'
        if (data == null || data == '') {
            return {
                text: intl.get('txt_zcd'),
                color: '#36B37E'
            };
        } else {
            let temp = data.split(',');
            let text = temp[3];
            let color = '#FF5230';

            if (text.indexOf(';') !== -1) {
                let temptext = '';
                let tempArr = text.split(';')
                tempArr.map(item => {
                    if (item == 'trauma_normal') {
                        temptext = temptext + intl.get('txt_zcd')

                    } else if (item == 'trauma_bulge') {
                        temptext = temptext + ' ' + intl.get('txt_gubao')
                    } else if (item == 'trauma_aging') {
                        temptext = temptext + ' ' + intl.get('txt_laohua')
                    } else if (item == 'trauma_lacerate') {
                        temptext = temptext + ' ' + intl.get('txt_gelie')
                    } else if (item == 'trauma_dropblock') {
                        temptext = temptext + ' ' + intl.get('txt_diaokuai')
                    } else if (item == 'trauma_puncture') {
                        temptext = temptext + ' ' + intl.get('txt_chaungci')
                    } else if (item == 'trauma_scratch') {
                        temptext = temptext + ' ' + intl.get('txt_cashang')
                    } else if (item == 'trauma_pinnate') {
                        temptext = temptext + ' ' + intl.get('txt_pinnate_wear')
                    }

                })
                text = temptext;
            } else {
                if (text == 'trauma_normal') {
                    text = intl.get('txt_zcd')
                    color = '#36B37E';
                } else if (text == 'trauma_bulge') {
                    text = intl.get('txt_gubao')
                } else if (text == 'trauma_aging') {
                    text = intl.get('txt_laohua')
                } else if (text == 'trauma_pinnate') {
                    text = intl.get('txt_pinnate_wear')
                } else if (text == 'trauma_scratch') {
                    text = intl.get('txt_cashang')
                } else if (text == 'trauma_puncture') {
                    text = intl.get('txt_chaungci')
                } else if (text == 'trauma_dropblock') {
                    text = intl.get('txt_diaokuai')
                } else if (text == 'trauma_lacerate') {
                    text = intl.get('txt_gelie')
                }
                else if (text.indexOf('trauma_other') !== -1) {
                    text = text.slice(12)
                } else {
                    text = intl.get('txt_zcd')
                    color = '#36B37E';
                }

            }
            let cd = returnTyreInfo(data, 5)
            if (text.indexOf('trauma_normal') == -1 && cd && cd == 'damage_low') {
                color = yellow
            }
            return {
                text: text,
                color: color
            };
        }
    };


    // 轮胎图片
    const returnTyre = (data) => {

        if (data) {
            if (data.indexOf("img1")>=0 && data.indexOf("img2")>0 && data.indexOf("img3")>0){
              let imgjson = JSON.parse(data)
              if (data.indexOf("img1")>=0 && imgjson.img2==='' && imgjson.img3===''){
                return (<img
                  style={{
                    width: 90,
                    height: 60
                  }}
                  resizemode="contain"
                  src={imgjson.img1==''?require("../../assets/report/noimage.png"):imgjson.img1} />);
              }else
              return (
                <div>
                  <img
                    style={{
                      width: 30,
                      height: 60
                    }}
                    resizemode="contain"
                    src={imgjson.img1} />
                    <img
                    style={{
                      width: 30,
                      height: 60
                    }}
                    resizemode="contain"
                    src={imgjson.img2} />
                    <img
                    style={{
                      width: 30,
                      height: 60
                    }}
                    resizemode="contain"
                    src={imgjson.img3} />
                </div>);
            }else{
              return (<img
                style={{
                  width: 90,
                  height: 60
                }}
                resizemode="contain"
                src={data} />);
            }
            
          } else {
            return (<div></div>)
          }

    };

    // 外伤正常
    const returnNomaimg = () => {

        return (<img
            style={{
                width: 90,
                height: 60
            }}
            resizemode="contain"
            src={require('../../assets/report/reportwszc.png')} />);


    };

    return (
        <div>
            {Object.entries(_data).map((item, index) => (
            <div
                    style={Object.assign(item[1].position, { position: "absolute" })}
                    key={index}  >
                 <div style={Object.assign(item[1].desc, { position: "absolute" })}>
                        <div className="wheelCarDesc">
                            <label
                                className="wheelCarDesc__label"
                                style={{
                                    width: '100px',
                                }} >
                                {returnTyrePosition(item[0])}：
                           </label>
                        </div>

                     {/* <div className="wheelCarDesc">
                        <span style={{ width: '100px', color: returnTyreStatus(item[1].info).color }} className="wheelCarDesc__cnt">
                                {returnTyreStatus(item[1].info).text}
                         </span>
                      </div> */}

                 </div>
                      <div style={{ marginTop: index <= 1 ? '22px' : '30px' }}>
                        {returnTyreStatus(item[1].info).text == intl.get('txt_zcd') ? returnNomaimg() : returnTyre(item[1].img)}
                      </div>
                  </div>
            ))}
        </div>
    );
};


{/** 轮胎续航里程 */ }
const Tyre_cllc = props => {
    const _data = props.data;
    let lang = intl.options.currentLocale
    let Ctime = props.time
    let Ctimeuser = Ctime.replace('T', ' ')
    let model = props.model

    _data.lf.position = { left: 10, top: 20 };
    _data.rf.position = { right: 10, top: 20 };
    _data.lb.position = { left: 10, top: lang == 'zh' ? 200 : 220 };
    _data.rb.position = { right: 10, top: lang == 'zh' ? 200 : 220 };

    _data.lf.desc = { left: 0, top: lang == 'zh' ? 70 : 100 };
    _data.rf.desc = { right: 0, top: lang == 'zh' ? 70 : 100 };
    _data.lb.desc = { left: 0, top: -50 };
    _data.rb.desc = { right: 0, top: -50 };

    // 返回轮胎位置
    const returnTyrePosition = key => {
        switch (key) {
            case "lf":
                return intl.get('txt_zqlun');
            case "lb":
                return intl.get('txt_zhlun');
            case "rf":
                return intl.get('txt_yqlun');
            case "rb":
                return intl.get('txt_yhlun');
        }
    };

    // 返回 信息
    const returnTyreInfo = (data, index) => {
        if (data) {
            return data.split(/,|，/)[index] ? data.split(/,|，/)[index] : "-";
        }
        return "-";
    };


    //返回对应位置轮胎的续航里程图片和文字提示
    const returenImgAndSuggess = (value, key, info) => {
        let data = value / 10;
        let temp = returnTyreInfo(info, 0);
        let waishang = returnTyreInfo(info, 3)
        let waishangcd = returnTyreInfo(info, 5)


        let images = key.indexOf('l') !== -1 ? [require(`../../assets/report/litem_2_1.png`),
        require(`../../assets/report/litem_2_2.png`),
        require(`../../assets/report/litem_2_3.png`),
        require(`../../assets/report/litem_2_4.png`),
        require(`../../assets/report/litem_2_5.png`),
        require(`../../assets/report/litem_2_6.png`),
        require(`../../assets/report/litem_2_7.png`),
        require(`../../assets/report/litem_2_8.png`),
        require(`../../assets/report/litem_2_9.png`),
        require(`../../assets/report/litem_2_10.png`),] : [require(`../../assets/report/ritem_2_1.png`),
        require(`../../assets/report/ritem_2_2.png`),
        require(`../../assets/report/ritem_2_3.png`),
        require(`../../assets/report/ritem_2_4.png`),
        require(`../../assets/report/ritem_2_5.png`),
        require(`../../assets/report/ritem_2_6.png`),
        require(`../../assets/report/ritem_2_7.png`),
        require(`../../assets/report/ritem_2_8.png`),
        require(`../../assets/report/ritem_2_9.png`),
        require(`../../assets/report/ritem_2_10.png`),]

        if ((waishang && waishang.indexOf('trauma_normal') == -1) && (waishangcd && waishangcd == 'damage_high')) {
            return {
                text: intl.get('txt_serious_trauma_check'),
                img: returnTyre(images[9])
            }
        }

        if (value < 25) {
            return {
                text: intl.get('txt_msyzljgh'),
                img: returnTyre(images[9])
            }
        }
        if (temp && temp.length >= 3) {

            var tmpdata = temp.slice(2);

            let thatyear = Number(tmpdata) + 2000
            let thatYearOfDay = (temp.length > 3 ? Number(temp.slice(0, 2)) : Number(temp.slice(0, 1))) * 7;
            let current_year = Ctimeuser.slice(0, 4);
            let dateFormat = Ctimeuser.replace(/-/g, '/'); // 将 - 转为 /  // 将-替换成/
            let currentYearOFday = Math.ceil((Date.parse(dateFormat) - new Date(new Date().getFullYear().toString())) / (24 * 60 * 60 * 1000)) + 1

            //每个轮子的使用天数 
            let RemainingDays = (currentYearOFday - thatYearOfDay) + (current_year - thatyear) * 365;
            if (RemainingDays >= 1820) {
                return {
                    text: intl.get('txt_tire_age_5'),
                    img: returnTyre(images[9])
                }
            }
        }
        let index, num;
        let str = intl.get('txt_ltlcgsnew')
        if (data <= 0.8) {
            index = 9
            num = 0
        } else if (data > 0.8 && data <= 1.6) {
            index = 8
            num = 0
        } else if (data > 1.6 && data <= 2.4) {
            index = 7
            num = 1600
        } else if (data > 2.4 && data <= 3.2) {
            index = 6
            num = 11200
        } else if (data > 3.2 && data <= 4) {
            index = 5
            num = 24000
        } else if (data > 4 && data <= 4.8) {
            index = 4
            num = 36800
        } else if (data > 4.8 && data <= 5.6) {
            index = 3
            num = 49600
        } else if (data > 5.6 && data <= 6.4) {
            index = 2
            num = 62400
        } else if (data > 6.4 && data <= 7.1) {
            index = 1
            num = 73600
        } else if (data > 7.1) {
            index = 0
            num = 80000
        }

        num = (value - 25) * 1000
        if (num > 50000) {
            num = 50000
        }

        {/** else {
        num = (value - 16) * 1270
        if (num > 80000) {
          num = 80000
        }
      }*/}

        if (num < 0) {
            num = 0
        }

        str = str.replace(new RegExp("\\{" + 0 + "\\}", "g"), num)
        if (num == 0) {
            str = intl.get('txt_msjxtx')
        }

        return {
            text: str,
            img: returnTyre(images[index])
        }

    }


    // 轮胎图片
    const returnTyre = (data) => {

        if (data) {
            return (<img
                style={{
                    width: 130,
                    height: 40
                }}
                resizemode="contain"
                src={data} />);
        } else {
            return (<div></div>)
        }

    };



    return (
        <div>
            {Object.entries(_data).map((item, index) => (
                <div
                    style={Object.assign(item[1].position, { position: "absolute" })}
                    key={index}
                >
                    <div >
                        <div className="wheelCarDesc">
                            <label
                                className="wheelCarDesc__label"
                                style={{
                                    width: '100px',

                                }}
                            >
                                {returnTyrePosition(item[0])}：
                </label>

                        </div>
                        <div className="wheelCarDesc">

                            <span style={{ width: '100px', height: lang == 'zh' ? '60px' : '80px' }} className="wheelCarDesc__cnt">
                                {returenImgAndSuggess(item[1].value, item[0], item[1].info).text}
                            </span>
                        </div>

                    </div>
                    <div style={Object.assign(item[1].desc, { position: "absolute" })}>
                        {returenImgAndSuggess(item[1].value, item[0], item[1].info).img}

                    </div>
                </div>
            ))}
        </div>
    );
};

{/** dot时间 */ }
const Tyre_dot = props => {
    const _data = props.data;
    let lang = intl.options.currentLocale
    let Ctime = props.time
    let Ctimeuser = Ctime.replace('T', ' ')

    _data.lf.position = { left: 10, top: lang == 'zh' ? 20 : 10 };
    _data.rf.position = { right: 10, top: lang == 'zh' ? 20 : 10 };
    _data.lb.position = { left: 10, top: lang == 'zh' ? 210 : 230 };
    _data.rb.position = { right: 10, top: lang == 'zh' ? 210 : 230 };

    _data.lf.desc = { left: 0, top: lang == 'zh' ? 80 : 115 };
    _data.rf.desc = { right: 0, top: lang == 'zh' ? 80 : 115 };
    _data.lb.desc = { left: 0, top: -50 };
    _data.rb.desc = { right: 0, top: -50 };

    // 返回轮胎位置
    const returnTyrePosition = key => {
        switch (key) {
            case "lf":
                return intl.get('txt_zqlun');
            case "lb":
                return intl.get('txt_zhlun');
            case "rf":
                return intl.get('txt_yqlun');
            case "rb":
                return intl.get('txt_yhlun');
        }
    };

    const returnDottx = (data) => {
        let temp = returnTyreInfo(data, 0);
        if (temp && temp.length >= 3) {
            var tmpdata = temp.slice(2);
            let thatyear = Number(tmpdata) + 2000
            let week = temp.slice(0, 2);
            console.log('temp=' + temp + 'tmpdata=' + tmpdata + 'week=' + week)
            let str = intl.get('txt_dotscsj')
            str = str.replace(new RegExp("\\{" + 0 + "\\}", "g"), temp)
            str = str.replace(new RegExp("\\{" + 1 + "\\}", "g"), thatyear)
            str = str.replace(new RegExp("\\{" + 2 + "\\}", "g"), week)
            return str
        } else {
            return intl.get('txt_whqdscsj')
        }
    }

    //返回每个轮子的图片index与提示文字
    const returnRemindTextAndImgIndex = (data, wear) => {
        let temp = returnTyreInfo(data, 0);
        let waishang = returnTyreInfo(data, 3)
        let waishangcd = returnTyreInfo(data, 5)

        console.log('wear=' + wear)
        if (waishang.indexOf('trauma_normal') > -1 || (waishang.indexOf('trauma_normal') == -1 && waishangcd && waishangcd == 'damage_low')) {

            if (wear && wear < 25) {
                return { index: 19, text: intl.get('txt_msyzljgh') }
            }
            if (temp && temp.length >= 3) {

                var tmpdata = temp.slice(2);

                let thatyear = Number(tmpdata) + 2000
                let thatYearOfDay = (temp.length > 3 ? Number(temp.slice(0, 2)) : Number(temp.slice(0, 1))) * 7;
                let current_year = Ctimeuser.slice(0, 4);
                let dateFormat = Ctimeuser.replace(/-/g, '/'); // 将 - 转为 /  // 将-替换成/
                let currentYearOFday = Math.ceil((Date.parse(dateFormat) - new Date(new Date().getFullYear().toString())) / (24 * 60 * 60 * 1000)) + 1
                console.log('currentYearOFday=' + currentYearOFday)
                //每个轮子的使用天数 
                let RemainingDays = (currentYearOFday - thatYearOfDay) + (current_year - thatyear) * 365;

                if (RemainingDays < 0) {
                    RemainingDays = 1820
                }
                if (RemainingDays >= 1820) {

                    return { index: 19, text: intl.get('txt_tire_age_5') }
                }
                //每个轮子的剩余使用天数
                let day = 1820 - RemainingDays

                let tm = (80 - wear) / (10 * RemainingDays)
                let day1 = (wear - 25) / (tm * 10)
                console.log('tm=' + tm + '---day=' + day + '----day1=' + day1 + 'RemainingDays' + RemainingDays)
                let chaju = RemainingDays;
                if (day1 < day && wear < 65) {
                    chaju = 1820 - day1
                    day = day1
                    day = parseInt(day)

                }

                if (day < 0) {
                    return { index: 19, text: intl.get('txt_tire_age_5') }
                }
                let index = 0
                if (chaju <= 182) {
                    index = 0
                } else if (chaju > 182 && chaju < 273) {
                    index = 1
                } else if (chaju >= 273 && chaju < 364) {
                    index = 2
                } else if (chaju >= 364 && chaju < 455) {
                    index = 3
                } else if (chaju >= 455 && chaju < 546) {
                    index = 4
                } else if (chaju >= 546 && chaju < 637) {
                    index = 5
                } else if (chaju >= 637 && chaju < 728) {
                    index = 6
                } else if (chaju >= 728 && chaju < 819) {
                    index = 7
                } else if (chaju >= 819 && chaju < 910) {
                    index = 8
                } else if (chaju >= 910 && chaju < 1001) {
                    index = 9
                } else if (chaju >= 1001 && chaju < 1092) {
                    index = 10
                } else if (chaju >= 1092 && chaju < 1183) {
                    index = 11
                } else if (chaju >= 1183 && chaju < 1274) {
                    index = 12
                } else if (chaju >= 1274 && chaju < 1365) {
                    index = 13
                } else if (chaju >= 1365 && chaju < 1456) {
                    index = 14
                } else if (chaju >= 1456 && chaju < 1547) {
                    index = 15
                } else if (chaju >= 1547 && chaju < 1638) {
                    index = 16
                } else if (chaju >= 1638 && chaju < 1729) {
                    index = 17
                } else if (chaju >= 1729 && chaju < 1820) {
                    index = 18
                } else if (chaju >= 1820) {
                    index = 19
                }
                let str = intl.get('txt_dotjstx')

                // str = str.replace(new RegExp("\\{" + 0 + "\\}", "g"), day)
                str = ''
                return {
                    index: index,
                    text: str
                }

            } else {

                return {
                    index: 0,
                    text: ''
                }
            }

        } else if (waishangcd && waishangcd == 'damage_high') {
            return {
                index: 19,
                text: intl.get('txt_serious_trauma_check')
            }
        } else {
            return {
                index: 0,
                text: ''
            }
        }

    }

    // 返回 信息
    const returnTyreInfo = (data, index) => {
        if (data) {
            return data.split(/,|，/)[index] ? data.split(/,|，/)[index] : "-";
        }
        return "-";
    };

    const Limages = intl.options.currentLocale == 'it' ? [

        require(`../../assets/report/LDotititem_2_1.png`),
        require(`../../assets/report/LDotititem_2_2.png`),
        require(`../../assets/report/LDotititem_2_3.png`),
        require(`../../assets/report/LDotititem_2_4.png`),
        require(`../../assets/report/LDotititem_2_5.png`),
        require(`../../assets/report/LDotititem_2_6.png`),
        require(`../../assets/report/LDotititem_2_7.png`),
        require(`../../assets/report/LDotititem_2_8.png`),
        require(`../../assets/report/LDotititem_2_9.png`),
        require(`../../assets/report/LDotititem_2_10.png`),
        require(`../../assets/report/LDotititem_2_11.png`),
        require(`../../assets/report/LDotititem_2_12.png`),
        require(`../../assets/report/LDotititem_2_13.png`),
        require(`../../assets/report/LDotititem_2_14.png`),
        require(`../../assets/report/LDotititem_2_15.png`),
        require(`../../assets/report/LDotititem_2_16.png`),
        require(`../../assets/report/LDotititem_2_17.png`),
        require(`../../assets/report/LDotititem_2_18.png`),
        require(`../../assets/report/LDotititem_2_19.png`),
        require(`../../assets/report/LDotititem_2_20.png`),
    ] : intl.options.currentLocale == 'zh' ? [

        require(`../../assets/report/LDotzhitem_2_1.png`),
        require(`../../assets/report/LDotzhitem_2_2.png`),
        require(`../../assets/report/LDotzhitem_2_3.png`),
        require(`../../assets/report/LDotzhitem_2_4.png`),
        require(`../../assets/report/LDotzhitem_2_5.png`),
        require(`../../assets/report/LDotzhitem_2_6.png`),
        require(`../../assets/report/LDotzhitem_2_7.png`),
        require(`../../assets/report/LDotzhitem_2_8.png`),
        require(`../../assets/report/LDotzhitem_2_9.png`),
        require(`../../assets/report/LDotzhitem_2_10.png`),
        require(`../../assets/report/LDotzhitem_2_11.png`),
        require(`../../assets/report/LDotzhitem_2_12.png`),
        require(`../../assets/report/LDotzhitem_2_13.png`),
        require(`../../assets/report/LDotzhitem_2_14.png`),
        require(`../../assets/report/LDotzhitem_2_15.png`),
        require(`../../assets/report/LDotzhitem_2_16.png`),
        require(`../../assets/report/LDotzhitem_2_17.png`),
        require(`../../assets/report/LDotzhitem_2_18.png`),
        require(`../../assets/report/LDotzhitem_2_19.png`),
        require(`../../assets/report/LDotzhitem_2_20.png`),
    ] : [
                require(`../../assets/report/LDotitem_2_1.png`),
                require(`../../assets/report/LDotitem_2_2.png`),
                require(`../../assets/report/LDotitem_2_3.png`),
                require(`../../assets/report/LDotitem_2_4.png`),
                require(`../../assets/report/LDotitem_2_5.png`),
                require(`../../assets/report/LDotitem_2_6.png`),
                require(`../../assets/report/LDotitem_2_7.png`),
                require(`../../assets/report/LDotitem_2_8.png`),
                require(`../../assets/report/LDotitem_2_9.png`),
                require(`../../assets/report/LDotitem_2_10.png`),
                require(`../../assets/report/LDotitem_2_11.png`),
                require(`../../assets/report/LDotitem_2_12.png`),
                require(`../../assets/report/LDotitem_2_13.png`),
                require(`../../assets/report/LDotitem_2_14.png`),
                require(`../../assets/report/LDotitem_2_15.png`),
                require(`../../assets/report/LDotitem_2_16.png`),
                require(`../../assets/report/LDotitem_2_17.png`),
                require(`../../assets/report/LDotitem_2_18.png`),
                require(`../../assets/report/LDotitem_2_19.png`),
                require(`../../assets/report/LDotitem_2_20.png`),
            ]

    const Rimages = intl.options.currentLocale == 'it' ? [
        require(`../../assets/report/RDotititem_2_1.png`),
        require(`../../assets/report/RDotititem_2_2.png`),
        require(`../../assets/report/RDotititem_2_3.png`),
        require(`../../assets/report/RDotititem_2_4.png`),
        require(`../../assets/report/RDotititem_2_5.png`),
        require(`../../assets/report/RDotititem_2_6.png`),
        require(`../../assets/report/RDotititem_2_7.png`),
        require(`../../assets/report/RDotititem_2_8.png`),
        require(`../../assets/report/RDotititem_2_9.png`),
        require(`../../assets/report/RDotititem_2_10.png`),
        require(`../../assets/report/RDotititem_2_11.png`),
        require(`../../assets/report/RDotititem_2_12.png`),
        require(`../../assets/report/RDotititem_2_13.png`),
        require(`../../assets/report/RDotititem_2_14.png`),
        require(`../../assets/report/RDotititem_2_15.png`),
        require(`../../assets/report/RDotititem_2_16.png`),
        require(`../../assets/report/RDotititem_2_17.png`),
        require(`../../assets/report/RDotititem_2_18.png`),
        require(`../../assets/report/RDotititem_2_19.png`),
        require(`../../assets/report/RDotititem_2_20.png`),
    ] : intl.options.currentLocale == 'zh' ? [

        require(`../../assets/report/RDotzhitem_2_1.png`),
        require(`../../assets/report/RDotzhitem_2_2.png`),
        require(`../../assets/report/RDotzhitem_2_3.png`),
        require(`../../assets/report/RDotzhitem_2_4.png`),
        require(`../../assets/report/RDotzhitem_2_5.png`),
        require(`../../assets/report/RDotzhitem_2_6.png`),
        require(`../../assets/report/RDotzhitem_2_7.png`),
        require(`../../assets/report/RDotzhitem_2_8.png`),
        require(`../../assets/report/RDotzhitem_2_9.png`),
        require(`../../assets/report/RDotzhitem_2_10.png`),
        require(`../../assets/report/RDotzhitem_2_11.png`),
        require(`../../assets/report/RDotzhitem_2_12.png`),
        require(`../../assets/report/RDotzhitem_2_13.png`),
        require(`../../assets/report/RDotzhitem_2_14.png`),
        require(`../../assets/report/RDotzhitem_2_15.png`),
        require(`../../assets/report/RDotzhitem_2_16.png`),
        require(`../../assets/report/RDotzhitem_2_17.png`),
        require(`../../assets/report/RDotzhitem_2_18.png`),
        require(`../../assets/report/RDotzhitem_2_19.png`),
        require(`../../assets/report/RDotzhitem_2_20.png`),
    ] : [
                require(`../../assets/report/RDotitem_2_1.png`),
                require(`../../assets/report/RDotitem_2_2.png`),
                require(`../../assets/report/RDotitem_2_3.png`),
                require(`../../assets/report/RDotitem_2_4.png`),
                require(`../../assets/report/RDotitem_2_5.png`),
                require(`../../assets/report/RDotitem_2_6.png`),
                require(`../../assets/report/RDotitem_2_7.png`),
                require(`../../assets/report/RDotitem_2_8.png`),
                require(`../../assets/report/RDotitem_2_9.png`),
                require(`../../assets/report/RDotitem_2_10.png`),
                require(`../../assets/report/RDotitem_2_11.png`),
                require(`../../assets/report/RDotitem_2_12.png`),
                require(`../../assets/report/RDotitem_2_13.png`),
                require(`../../assets/report/RDotitem_2_14.png`),
                require(`../../assets/report/RDotitem_2_15.png`),
                require(`../../assets/report/RDotitem_2_16.png`),
                require(`../../assets/report/RDotitem_2_17.png`),
                require(`../../assets/report/RDotitem_2_18.png`),
                require(`../../assets/report/RDotitem_2_19.png`),
                require(`../../assets/report/RDotitem_2_20.png`),
            ]


    return (
        <div>
            {Object.entries(_data).map((item, index) => (
                <div
                    style={Object.assign(item[1].position, { position: "absolute" })}
                    key={index}
                >
                    <div >
                        <div className="wheelCarDesc">
                            <label
                                className="wheelCarDesc__label"
                                style={{
                                    width: '100px',

                                }}
                            >
                                {returnTyrePosition(item[0])}：
                </label>

                        </div>

                        <div className={lang == 'zh' ? "wheelCarDesc" : 'wheelCarDesc1'} >
                            <span style={{ width: '120px', }} className="wheelCarDesc__cnt">
                                {returnDottx(item[1].info)}
                            </span>
                        </div>
                        <div className={lang == 'zh' ? "wheelCarDesc" : "wheelCarDesc1"}>

                            <span style={{ width: '120px', height: (lang == 'zh' || lang == 'it') ? '60px' : '120px' }} className="wheelCarDesc__cnt">
                                {returnRemindTextAndImgIndex(item[1].info, item[1].wear).text}
                            </span>
                        </div>

                    </div>
                    <div style={Object.assign(item[1].desc, { position: "absolute", marginTop: '0px' })}>
                        <img
                            style={{
                                width: 130,
                                height: 40
                            }}
                            resizemode="contain"
                            src={(index == 0 || index == 2) ? Limages[returnRemindTextAndImgIndex(item[1].info, item[1].wear).index] : Rimages[returnRemindTextAndImgIndex(item[1].info, item[1].wear).index]} />
                    </div>
                </div>
            ))}
        </div>
    );
};

// 刹车距离组件
const BrakeBar = props => {
    let level = props.level;
    let images = [
        require(`../../assets/report/item_2_1.png`),
        require(`../../assets/report/item_2_2.png`),
        require(`../../assets/report/item_2_3.png`),
        require(`../../assets/report/item_2_4.png`),
        require(`../../assets/report/item_2_5.png`),
        require(`../../assets/report/item_2_6.png`),
        require(`../../assets/report/item_2_7.png`),
        require(`../../assets/report/item_2_8.png`),
        require(`../../assets/report/item_2_9.png`),
        require(`../../assets/report/item_2_10.png`),
    ]
    let imagesll = [
        require(`../../assets/report/item_2_1ll.png`),
        require(`../../assets/report/item_2_2ll.png`),
        require(`../../assets/report/item_2_3ll.png`),
        require(`../../assets/report/item_2_4ll.png`),
        require(`../../assets/report/item_2_5ll.png`),
        require(`../../assets/report/item_2_6ll.png`),
        require(`../../assets/report/item_2_7ll.png`),
        require(`../../assets/report/item_2_8ll.png`),
        require(`../../assets/report/item_2_9ll.png`),
        require(`../../assets/report/item_2_10ll.png`),
    ]
    return (
        <img
            style={{ width: "100%", marginTop: -20, objectFit: "contain" }}
            src={intl.options.currentLocale == 'zh' ? images[level - 1] : imagesll[level - 1]}
            alt=""
        />
    );
};




// WEBPACK FOOTER //
// ./src/views/report/ReportDill.js